$(document).ready(function () {
  if($('#noticeModalCenter').length) {
    $('#noticeModalCenter').modal();
  }
});
